import React from 'react';
import { connect } from 'react-redux';
import PromiseCreator from 'promise-creator';
import PropTypes from 'prop-types';
import { changeUserInfoAction } from '../../redux/me';
import UbeuExtraInformation from './UbeuExtraInformation';
import NorthWestExtraInformation from './NorthWestExtraInformation';
import SpartanExtraInformation from './SpartanExtraInformation';
import NustarExtraInformation from './NustarExtraInformation';
import SetOnHomeHSExtraInformation from './SetOnHomeHSExtraInformation';
import SecondaryEmailExtraInformation from './SecondaryEmailExtraInformation';
import SITE_MODES from '../../../constants/site-modes';

const ExtraUserInformation = ({
    changeUserInfo,
    companyDomain,
    siteMode,
    requestSecondaryEmail,
}) => {
    if (siteMode !== SITE_MODES.EDUCATION) {
        return null;
    }
    let Form = null;
    if (companyDomain === 'ubeu') {
        Form = UbeuExtraInformation;
    } else if (companyDomain === 'nwtcadmissions') {
        Form = NorthWestExtraInformation;
    } else if (companyDomain === 'spartan') {
        Form = SpartanExtraInformation;
    } else if (companyDomain === 'nustaredu') {
        Form = NustarExtraInformation;
    } else if (companyDomain === 'setonhomehs') {
        Form = SetOnHomeHSExtraInformation;
    } else if (requestSecondaryEmail) {
        Form = SecondaryEmailExtraInformation;
    } else {
        return null;
    }

    return (
        <Form
            onSubmit={(form) => {
                const { resolve, reject, promise } = PromiseCreator();
                changeUserInfo({
                    resolve,
                    reject,
                    ...form,
                });
                return promise;
            }}
        />
    );
};

ExtraUserInformation.propTypes = {
    changeUserInfo: PropTypes.func,
    siteMode: PropTypes.number,
    companyDomain: PropTypes.string,
    requestSecondaryEmail: PropTypes.bool,
};

export default connect(
    ({ theme }) => ({
        companyDomain: theme.companyDomain,
        siteMode: theme.siteMode,
        requestSecondaryEmail: theme.requestSecondaryEmail,
    }),
    {
        changeUserInfo: changeUserInfoAction,
    },
)(ExtraUserInformation);



// WEBPACK FOOTER //
// ./src/client/Components/ExtraUserInformation/ExtraUserInformation.js